<div class="main-container">
    <div class="login-container">
        <div class="loading-block" *ngIf="loading">
            <img class="loader" src="./assets/images/loader.gif"/>
            <div class="message">{{ loadingMessage }}</div>
        </div>
        <div *ngIf="!loading && loggedout" class="content-block">
            <div class="status-pill">Logged out</div>
            <div class="message">You are logged out successfully</div>
            <button *ngIf="loginFeatureEnabled" class="action-btn" (click)="login()">Login again</button>
        </div>
    </div>
</div>